export function convertUrl(url: string): string {
	const regex = /^http(s?):\/\//;

	if (regex.test(url)) {
		return url;
	}

	return `https://${url}`;
}
